import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group';

import s from './WithFade.module.css';

const WithFade = ({ component, className, children }) => (
  <CSSTransitionGroup
    component={component}
    className={className}
    transitionName={{
      enter: s.enter,
      enterActive: s.enterActive,
      leave: s.leave,
      leaveActive: s.leaveActive,
    }}
    transitionEnterTimeout={150}
    transitionLeaveTimeout={150}
  >
    {children}
  </CSSTransitionGroup>
);

WithFade.propTypes = {
  component: PropTypes.oneOf(['span', 'div']),
  className: PropTypes.string,
};

WithFade.defaultProps = {
  component: 'span',
};

export default WithFade;
